// Mock data for UK Cerrajeros locksmith business

export const services = [
  {
    id: 1,
    title: 'Puertas para Vivienda',
    description: 'Puertas de seguridad y acorazadas para pisos, chalets y negocios. Instalación profesional con garantía total.',
    icon: 'DoorClosed'
  },
  {
    id: 2,
    title: 'Puertas para Trastero',
    description: 'Puertas de acero, antirobo. Compatibles con puertas Roper o acorazadas estándar.',
    icon: 'DoorClosed',
    highlight: 'novatea'
  },
  {
    id: 3,
    title: 'Instalación de Cerraduras',
    description: 'Cerraduras electrónicas y mecánicas. Antibumping, antiganzúa, antitaladro. Configuración personalizada según tus necesidades.',
    icon: 'Lock'
  },
  {
    id: 4,
    title: 'Mantenimiento',
    description: 'Servicio preventivo y correctivo para mantener tu sistema de seguridad en óptimas condiciones.',
    icon: 'Wrench'
  }
];

export const projects = [
  {
    id: 1,
    title: 'Puerta Acorazada Clásica',
    category: 'Puertas',
    image: '/images/puertas/1760470885382.jpg',
    description: 'Estilo clásico con protección avanzada'
  },
  {
    id: 2,
    title: 'Sistema de Cerradura Multicerojo',
    category: 'Cerraduras',
    image: '/images/cerraduras/IMG_20250511_152726.jpg',
    description: 'Instalación de cerradura con múltiples puntos de cierre'
  },
  {
    id: 3,
    title: 'Puerta Blindada Oscura',
    category: 'Puertas',
    image: '/images/puertas/IMG_20230329_133746.jpg',
    description: 'Acabado oscuro con protección máxima'
  },
  {
    id: 4,
    title: 'Instalación Cerradura de Seguridad',
    category: 'Cerraduras',
    image: '/images/cerraduras/IMG_20231219_153042.jpg',
    description: 'Cerradura de alta seguridad antibumping y antiganzúa'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Cliente Verificado',
    date: 'Hace 2 meses',
    text: 'Servicio excelente, muy profesionales y rápidos. Instalaron una puerta acorazada en mi piso y quedó perfecta. Totalmente recomendable.',
    rating: 5,
    verified: true
  },
  {
    id: 2,
    name: 'Cliente Verificado',
    date: 'Hace 3 meses',
    text: 'Muy contentos con el trabajo realizado. Cambiaron las cerraduras de toda la casa y nos asesoraron muy bien sobre las opciones de seguridad.',
    rating: 5,
    verified: true
  },
  {
    id: 3,
    name: 'Cliente Verificado',
    date: 'Hace 1 mes',
    text: 'Instalaron puertas Novatea en los trasteros de nuestra comunidad. Trabajo impecable y muy buen precio. Los recomiendo sin duda.',
    rating: 5,
    verified: true
  },
  {
    id: 4,
    name: 'Cliente Verificado',
    date: 'Hace 4 meses',
    text: 'Profesionales de confianza. Solucionaron un problema urgente de cerradura el mismo día. Muy agradecido por la rapidez y eficacia.',
    rating: 5,
    verified: true
  }
];

export const puertasTrastero = [
  {
    id: 1,
    title: 'Puerta de Trastero Novatea',
    image: '/images/trasteros/puerta_novatea_nueva.jpg',
    description: 'Acorazada. Compatible con puertas de trastero Roper',
    novatea: true
  },
  {
    id: 2,
    title: 'Puerta de Trastero Acorazada',
    image: '/images/trasteros/puerta_trastero_acorazada.jpg',
    description: 'Acorazada estándar para instalación con obra de albañilería',
    novatea: false
  }
];

export const puertasVivienda = [
  {
    id: 1,
    title: 'Puerta Acorazada Básica',
    image: '/images/puertas/puerta_basica.jpg',
    description: 'Solución esencial de seguridad',
    features: [
      'Estructura de acero reforzado',
      'Cerradura de seguridad básica',
      'Medida estándar',
      'Instalación incluida'
    ]
  },
  {
    id: 2,
    title: 'Puerta Acorazada Estándar',
    image: '/images/puertas/puerta_estandar.jpg',
    description: 'Seguridad avanzada con garantía extendida',
    features: [
      'Certificado de seguridad',
      'Estructura de acero reforzado',
      'Cerradura de alta seguridad',
      'Escudo protector anti extracción',
      'Medida estándar o a medida',
      'Garantía extendida 5 años'
    ]
  },
  {
    id: 3,
    title: 'Puerta Acorazada Premium',
    image: '/images/puertas/puerta_premium.jpg',
    description: 'Máxima protección y seguridad',
    features: [
      'Certificado de seguridad',
      'Estructura de acero reforzado',
      'Cerradura de máxima seguridad',
      'Escudo protector anti extracción',
      'Sistema de bloqueo por intrusión',
      'Medida estándar o a medida',
      'Garantía extendida 5 años'
    ]
  }
];

export const cerraduras = [
  {
    id: 1,
    title: 'Cerrojos de Alta Seguridad',
    image: '/images/cerraduras/IMG_20231219_153042.jpg',
    description: 'Seguridad adicional con llaves de alta seguridad'
  },
  {
    id: 2,
    title: 'Mejoras de Seguridad',
    image: '/images/cerraduras/IMG_20250511_152726.jpg',
    description: 'Aumenta la seguridad de tu cerradura actual'
  },
  {
    id: 3,
    title: 'Cerradura Electrónica',
    image: '/images/cerraduras/cerradura_electronica_nueva.jpg',
    description: 'Abre y cierra usando tu smartphone como llave'
  }
];

export const contactInfo = {
  phone: '619 827 227',
  whatsapp: '619827227',
  email: 'info@ukcerrajeros.com',
  address: 'Serantes Kalea, 3, 48930 Areeta / Las Arenas, Bizkaia',
  schedule: '10:00–14:00 y 16:00-19:00'
};
